import {
  SET_ERROR,
  VTR_LIST_ERROR,
  VTR_LIST_REQUEST,
  VTR_LIST_SUCCESS,
} from './actionTypes';

export const vtrListRequest = (client_id, token, user_app_status) => {
  if (!client_id || !token) {
    console.error('vtrListRequest', 'no client_id or token provided');
    console.error('vtrListRequest', client_id);
    console.error('vtrListRequest', token);
    return {
      type: SET_ERROR,
      error: 'no client_id or token provided',
    };
  }
  if (!user_app_status) {
    console.error('vtrListRequest', 'Unknown user status');
    return {
      type: SET_ERROR,
      error: 'Unknown user status',
    };
  }
  return {
    type: VTR_LIST_REQUEST,
    client_id: client_id,
    token: token,
    user_app_status: user_app_status,
  };
};

export const vtrLoadSucces = ({ response, client_id }) => {
  return {
    type: VTR_LIST_SUCCESS,
    data: response,
    client_id,
  };
};

export const vtrLoadError = ({ error }) => {
  return {
    type: VTR_LIST_ERROR,
    error: error,
  };
};
